import React from 'react'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { Icon, Text, Title, Wrapper } from './views'
// utils
import { getChartErrorMessage } from 'utils/charts/errors'

interface Props {
  error: unknown
  onClose: () => void
}

// In place of the settings form when the saved chart failed to load: a form on the defaults would overwrite it
const ChartLoadError: React.FC<Props> = ({ error, onClose }) => (
  <Wrapper role='alert'>
    <Icon />
    <Title>Could not load the chart</Title>
    <Text>{getChartErrorMessage(error, 'Please close the settings and try again later.')}</Text>
    <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={onClose}>
      Close
    </Button>
  </Wrapper>
)

export default ChartLoadError
